import { useState } from "react";
import { Link } from "react-router-dom";
import { X, Eye, Users, FileText, Activity, ClipboardList } from "lucide-react";

const STEPS = [
  { icon: Users, text: "Abre un paciente y revisa su historial completo" },
  { icon: ClipboardList, text: "Inicia una nueva consulta geriátrica" },
  { icon: ClipboardList, text: "Registra una consulta estructurada" },
  { icon: FileText, text: "Genera un informe PDF automático" },
];

export default function DemoBanner() {
  const [expanded, setExpanded] = useState(true);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="border-b border-emerald-200 bg-emerald-50 px-4 py-3 lg:px-8 shrink-0 no-print print:hidden">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-2 shrink-0">
          <div className="flex h-7 w-7 items-center justify-center rounded-full bg-emerald-600">
            <Eye className="h-3.5 w-3.5 text-white" />
          </div>
          <div>
            <p className="text-sm font-semibold text-emerald-900">
              Modo Demo — Aurora Geriátrica
            </p>
            <p className="text-xs text-emerald-700">
              Estás explorando con datos de ejemplo. Navega libremente.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={() => setExpanded(!expanded)}
            className="text-xs font-medium text-emerald-700 hover:text-emerald-900 underline underline-offset-2"
          >
            {expanded ? "Ocultar guía" : "Ver guía"}
          </button>
          <button
            onClick={() => setDismissed(true)}
            className="flex h-6 w-6 items-center justify-center rounded-full text-emerald-600 hover:bg-emerald-100"
            aria-label="Cerrar banner"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>

      {expanded && (
        <div className="mt-3 grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map(({ icon: Icon, text }, i) => (
            <div
              key={i}
              className="flex items-center gap-2.5 rounded-xl border border-emerald-200 bg-white px-3 py-2 shadow-sm"
            >
              <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-emerald-50 border border-emerald-100">
                <Icon className="h-3.5 w-3.5 text-emerald-600" />
              </div>
              <p className="text-xs font-medium text-slate-700">
                <span className="mr-1 font-bold text-emerald-600">{i + 1}.</span>
                {text}
              </p>
            </div>
          ))}
        </div>
      )}

      <div className="mt-3 flex flex-wrap items-center gap-3">
        <Link
          to="/register"
          className="inline-flex items-center rounded-lg bg-emerald-600 px-3 py-1.5 text-xs font-semibold text-white shadow-sm hover:bg-emerald-700"
        >
          Crear mi cuenta gratis →
        </Link>
        <p className="text-xs text-emerald-700">
          14 días gratis · Sin tarjeta · Acceso inmediato
        </p>
      </div>
    </div>
  );
}
